import styled from 'styled-components';
import { color } from 'styles/colors';

export const container: any = styled.div`
  width: 100%;
  max-height: 60vh;
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 0.5rem;
`;

export const boxInput: any = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > div {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    > p {
      font-weight: 600;
      > b {
        color: ${color.system.error};
      }
    }
  }
`;

export const treeInputs = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;

  @media (max-width: 540px) {
    grid-template-columns: 1fr;
  }
`;
